import {createRouter, createWebHistory} from 'vue-router'

import Login from '../views/Login.vue'
import Project from '../views/Project.vue'

//import Debug from '../views/Debug.vue'
import NotFound from "../views/NotFound.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import InDesignExport from "@/views/InDesignExport.vue";
import EMagazinePages from "@/components/Administration/Magazine/EMagazinePages.vue";
import EUser from "@/components/Administration/User/EUser.vue";
import CUser from "@/components/Administration/User/CUser.vue";
import CPurchaser from "@/components/Administration/Purchaser/CPurchaser.vue";
import EPurchaser from "@/components/Administration/Purchaser/EPurchaser.vue";
import Benchmark from "@/views/Benchmark.vue";
import SuperAdmin from "@/components/Administration/SuperAdmin/SuperAdmin.vue";


import EFormular from "@/components/Administration/Formular/EFormular.vue";
import CFormular from "@/components/Administration/Formular/CFormular.vue";
import CProduktField from "@/components/Administration/ProduktField/CProduktField.vue";
import EMarket from "@/components/Administration/Market/EMarket.vue";
import CMarket from "@/components/Administration/Market/CMarket.vue";
import EProductField from "@/components/Administration/ProduktField/EProductField.vue";
import CMagazineType from "@/components/Administration/Magazine/CMagazineType.vue";
import EMagazineType from "@/components/Administration/Magazine/EMagazineType.vue";
import VOverview from "@/components/Administration/Project/VOverview.vue";
import EArticle from "@/components/Administration/Artikel/EArticle.vue";
import User from "@/views/User.vue";
import export_indesign from "@/views/export_indesign.vue";

import ListView from "../views/ListView.vue";
import SortView from "@/views/SortView.vue";
import Print from "@/views/Print.vue";
import ETemplate from "@/components/Administration/Templates/ETemplate.vue";
import Asset from "@/views/Asset.vue";
import Article from "@/views/Article.vue";
import Apps from "@/views/Apps.vue";
import Help from "@/views/Help.vue";
import CRule from "@/components/Administration/Rule/CRule.vue";
import CSQLSkript from "@/components/Administration/SuperAdmin/CSQLSkript.vue";
import NoAccess from "@/views/NoAccess.vue";
import EApi from "@/components/Administration/Api/EApi.vue";
import CApi from "@/components/Administration/Api/CApi.vue";

const routes = [
    {
        path: '/user/:login?',
        name: 'user',
        component: User,
        meta: {}
    }, {
        path: '/export/indesign',
        name: 'export_indesign',
        component: export_indesign,
        meta: {}
    }, {
        path: '/project/:projectId?/:magazineId?/:pagePosition?/:marketId?/:accordionIndex?',
        name: 'Project',
        component: Project
    }, {
        path: '/list/:projectId?/:magazineId?/:pagePosition?/:marketId?',
        component: ListView,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/sort/:projectId?/:magazineId?/:pagePosition?/:marketId?',
        name: 'ListView',
        component: SortView,
    }, {
        path: '/print/:magazineId?/:startPage?/:endPage?/:showNumbers?/:showNotes?/:marketIds?',
        name: 'Print',
        component: Print,
        meta: {
            hideNavbar: true,
            fullscreen: true,
            screenPadding: false
        }
    }, {
        path: '/noaccess',
        name: 'NoAccess',
        component: NoAccess,
        meta: {
            hideNavbar: true,
            fullscreen: true,
            screenPadding: false
        }
    }, {
        path: '/grid',
        name: 'Raster',
        component: PageGrid
    }, {
        path: '/help',
        name: 'Hilfe',
        component: Help,
        children: [
            {
                path: ':pathMatch(.*)*',
                component: Help
            }
        ]
    }, {
        path: '/administration/:accordionIndex?/:projectId?',
        name: 'Administration',
        component: VOverview,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/export',
        name: 'Export',
        component: InDesignExport
    }, {
        path: '/asset',
        name: 'Asset',
        component: Asset,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/apps',
        name: 'Apps',
        component: Apps,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/article/:articleNumber?',
        name: 'article',
        component: Article,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/page/:projectId?/:magazineId?/:pagePosition?/:marketId?',
        name: 'AdministrationProjekt',
        component: EMagazinePages,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/user/:userId?',
        name: 'AdministrationUser',
        component: EUser,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/template/:templateGroupId?/:templateId?',
        name: 'Template',
        component: ETemplate,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/market/:marketId?',
        name: 'AdministrationMarket',
        component: EMarket,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/marketType/:marketTypeId?',
        name: 'AdministrationMagazineType',
        component: EMagazineType,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/team/:teamId?',
        name: 'AdministrationIcon',
        component: EPurchaser,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/article/:productId?',
        name: 'EditArticle',
        component: EArticle,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/formular/:formId?',
        name: 'editFormular',
        component: EFormular,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/superAdmin/:tableName?',
        name: 'SuperAdmin',
        component: SuperAdmin,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/product/:productFieldId?',
        name: 'AdministrationProductField',
        component: EProductField,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/rule/:ruleId',
        name: 'EditRule',
        component: CRule,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },{
        path: '/administration/:accordionIndex?/createApiKey',
        name: 'CreatApiKey',
        component: CApi,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },{
        path: '/administration/:accordionIndex?/apiKey/:apiKeyId',
        name: 'EditApiKey',
        component: EApi,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/creatUser',
        name: 'CreatUser',
        component: CUser,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/createMarket',
        name: 'CreateMarket',
        component: CMarket,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/createMarketType',
        name: 'CreateMarketType',
        component: CMagazineType,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/createCustomField',
        name: 'CreateCustomField',
        component: CProduktField,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },
    {
        path: '/administration/:accordionIndex?/createRule',
        name: 'createRule',
        component: CRule,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },{
        path: '/administration/:accordionIndex?/createSQLSkript',
        name: 'CreateMarket',
        component: CSQLSkript,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    },


    {
        path: '/administration/:accordionIndex?/createFormular',
        name: 'CreateFormular',
        component: CFormular,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: '/administration/:accordionIndex?/createTeam',
        name: 'CreateTeam',
        component: CPurchaser,
        meta: {
            fullscreen: true,
            screenPadding: true
        }
    }, {
        path: "/:catchAll(.*)",
        component: NotFound,
    }, {
        path: '/benchmark',
        name: 'Benchmark',
        component: Benchmark,
        props: true,
        meta: {
            hideNavbar: true,
            fullscreen: true,
            screenPadding: false
        }
    }, {
        path: '/login',
        name: 'Login',
        component: Login,
        props: true,
        meta: {
            hideNavbar: true,
            fullscreen: true,
            screenPadding: false,
            theme: 'light',
        }
    },


    /*
    {
      path: '/product',
      name: 'About',
      component: () => import(/ * webpackChunkName: "about" * / '../views/About.vue')
    }
    */
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

/*
router.beforeEach((to, from, next) => {
  let jwt = cookieHelper.getCookie("jwt");




  /*
  if(to.path.indexOf("/assetproductdetail") > -1) {
    app.config.globalProperties.showMenu = false;
    next();
  }
  * /

  if (to.path === "/") {
    router.push('/login');
  } else if (to.path === "/logout") {
    cookieHelper.setCookie("jwt", "", 0);
    router.push('/login');
  } else if (to.path === "/login") {
    if (jwt !== "") {
      router.push('/project');
    } else {
      next();
    }
  } else {
    next();
  }
});
*/

export default router
